// extracted by mini-css-extract-plugin
export default {"heading":"IdleStage_heading__YtYpF","input":"IdleStage_input__XYIbC","button":"IdleStage_button__McWjD"};